var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g, _path1, _path10, _path11, _path12, _path13, _path14, _g2, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlagEs = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 32 24"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "flag-es_svg__a",
  width: 32,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v24H0z"
}))), /*#__PURE__*/React.createElement("g", {
  mask: "url(#flag-es_svg__a)"
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFB400",
  fillRule: "evenodd",
  d: "M0 0v24h32V0z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("mask", {
  id: "flag-es_svg__b",
  width: 32,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M0 0v24h32V0z",
  clipRule: "evenodd"
}))), /*#__PURE__*/React.createElement("g", {
  mask: "url(#flag-es_svg__b)"
}, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#C51918",
  fillRule: "evenodd",
  d: "M0 0v6h32V0zM0 18v6h32v-6z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#F1F9FF",
  d: "M5.008 10.272h1.12v5.824h-1.12z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#C88A02",
  d: "M6.576 9.824H6.24v.448H4.896v-.448H4.56v-.56h2.016z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#C88A02",
  fillRule: "evenodd",
  d: "M6.24 16.432h.336v.56H4.56v-.56h.336v-.448H6.24z",
  clipRule: "evenodd"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#AD1619",
  fillRule: "evenodd",
  d: "M5.568 9.376c.244 0 .268-.092.412-.229.112-.106.372-.238.372-.387 0-.34-.351-.616-.784-.616s-.784.276-.784.616c0 .166.179.276.314.387.143.117.248.229.47.229",
  clipRule: "evenodd"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#005BBF",
  fillRule: "evenodd",
  d: "M4.56 16.992h2.016v.896s-.252-.112-.504-.112-.504.112-.504.112-.252-.112-.504-.112-.504.112-.504.112z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("mask", {
  id: "flag-es_svg__c",
  width: 3,
  height: 2,
  x: 4,
  y: 16,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M4.56 16.992h2.016v.896s-.252-.112-.504-.112-.504.112-.504.112-.252-.112-.504-.112-.504.112-.504.112z",
  clipRule: "evenodd"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  mask: "url(#flag-es_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m4.542 17.712-.044-.107q.272-.122.546-.122c.118 0 .18.017.284.063a.5.5 0 0 0 .24.054.5.5 0 0 0 .24-.054.6.6 0 0 1 .285-.063q.273 0 .546.122l-.044.107a1.2 1.2 0 0 0-.502-.112.5.5 0 0 0-.24.054.6.6 0 0 1-.285.063.6.6 0 0 1-.284-.063.5.5 0 0 0-.24-.054q-.25 0-.502.112M4.542 17.376l-.044-.107q.272-.122.546-.122c.118 0 .18.017.284.063a.5.5 0 0 0 .24.054.5.5 0 0 0 .24-.054.6.6 0 0 1 .285-.063q.273 0 .546.122l-.044.107a1.2 1.2 0 0 0-.502-.112.5.5 0 0 0-.24.054.6.6 0 0 1-.285.063.6.6 0 0 1-.284-.063.5.5 0 0 0-.24-.054q-.25 0-.502.112"
}))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#F1F9FF",
  d: "M15.984 10.272h1.12v5.824h-1.12z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#C88A02",
  d: "M17.552 9.824h-.336v.448h-1.344v-.448h-.336v-.56h2.016z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#C88A02",
  fillRule: "evenodd",
  d: "M17.216 16.432h.336v.56h-2.016v-.56h.336v-.448h1.344z",
  clipRule: "evenodd"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#AD1619",
  fillRule: "evenodd",
  d: "M16.544 9.376c.244 0 .268-.092.412-.229.112-.106.372-.238.372-.387 0-.34-.351-.616-.784-.616s-.784.276-.784.616c0 .166.18.276.315.387.142.117.247.229.469.229",
  clipRule: "evenodd"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#005BBF",
  fillRule: "evenodd",
  d: "M15.536 16.992h2.016v.896s-.252-.112-.504-.112-.504.112-.504.112-.252-.112-.504-.112-.504.112-.504.112z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("mask", {
  id: "flag-es_svg__d",
  width: 3,
  height: 2,
  x: 15,
  y: 16,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M15.536 16.992h2.016v.896s-.252-.112-.504-.112-.504.112-.504.112-.252-.112-.504-.112-.504.112-.504.112z",
  clipRule: "evenodd"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  mask: "url(#flag-es_svg__d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m15.518 17.712-.044-.107q.272-.122.546-.122c.118 0 .18.017.284.063a.5.5 0 0 0 .24.054.5.5 0 0 0 .24-.054.6.6 0 0 1 .285-.063q.273 0 .546.122l-.044.107a1.2 1.2 0 0 0-.502-.112c-.1 0-.148.013-.24.054a.6.6 0 0 1-.285.063.6.6 0 0 1-.284-.063.5.5 0 0 0-.24-.054q-.25 0-.502.112M15.518 17.376l-.044-.107q.272-.122.546-.122c.118 0 .18.017.284.063a.5.5 0 0 0 .24.054.5.5 0 0 0 .24-.054.6.6 0 0 1 .285-.063q.273 0 .546.122l-.044.107a1.2 1.2 0 0 0-.502-.112c-.1 0-.148.013-.24.054a.6.6 0 0 1-.285.063.6.6 0 0 1-.284-.063.5.5 0 0 0-.24-.054q-.25 0-.502.112"
}))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#AD1619",
  fillRule: "evenodd",
  d: "M4.388 11.872c.75-.516 2.758-.563 3.64-.108l-.412.796c-.432-.223-1.415-.265-2.103-.15l.353.058.394.06c.275.043.463.097.601.192a.536.536 0 0 1 .124.799c-.086.108-.198.189-.367.287l-.191.105-.192.103c-.162.086-.268.15-.347.207-.124.09-.252.163-.396.232-.077.037-.295.132-.298.134l-.013.006a.63.63 0 0 1 .122.383c0 .236-.114.459-.316.704l-.687-.568-.065-.02-.037-.286c-.067-.53.159-.822.624-1.034.013-.006.224-.098.284-.126.098-.048.179-.095.255-.15q.109-.08.251-.162c-.576-.093-.888-.16-1.127-.264-.573-.246-.647-.819-.097-1.198m9.593-.108c.88-.455 2.89-.409 3.64.108.55.379.476.952-.096 1.198-.24.103-.552.171-1.128.264.096.056.176.108.25.162.076.055.158.102.257.15.06.029.27.12.282.125.466.212.692.505.625 1.035l-.036.287-.067.02-.687.567c-.202-.245-.315-.468-.315-.704 0-.15.044-.278.122-.383l-.013-.006c-.008-.003-.223-.097-.3-.134a2.5 2.5 0 0 1-.394-.232 3 3 0 0 0-.346-.207l-.193-.103-.191-.105c-.17-.098-.281-.18-.366-.287a.536.536 0 0 1 .123-.8c.139-.094.326-.148.601-.19l.394-.061q.197-.03.353-.059c-.688-.114-1.672-.073-2.104.15z",
  clipRule: "evenodd"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#F1F9FF",
  d: "m5.923 12.4.331.068v.493c-.352.281-1.246.755-1.246.755V12.4zM16.315 12.4l-.331.068v.493c.352.281 1.246.755 1.246.755V12.4z"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#AD1619",
  fillRule: "evenodd",
  d: "M9.262 6.422s.938-.405 1.869-.314l-.001.002q.93-.09 1.837.312.945 0 1.81.62v.164l-1.13 1.134c-.226.626-.63.66-.943.764-.105.034-1.55.074-1.577.075v-.004C8.9 9.432 8.582 8.34 8.582 8.34l-1.13-1.134v-.164s.864-.62 1.81-.62",
  clipRule: "evenodd"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#C88A02",
  d: "M12.87 7.501c.024.28.1.41.213.428q.23.037.35-.03l.166-.09v.152a1 1 0 0 0 .264-.03l.035.162.826-.776.076.082-1.027.966c-.15.276-.226.458-.226.534 0 .115-.3.183-.887.254-.459.055-1 .09-1.444.095v.003l-.057-.002-.055.002v-.003c-.443-.005-.985-.04-1.445-.095-.586-.07-.886-.139-.886-.254a.3.3 0 0 0-.012-.062.9.9 0 0 1-.123-.298l-.09-.174-.228-.214-.006-.001v-.004l-.794-.747.077-.082.745.701.02-.087q.183.04.262.03V7.81l.165.09q.123.067.352.03c.112-.018.189-.149.214-.428l.05-.562.168.539c.076.244.193.352.358.352.161 0 .226-.06.233-.208l.02-.424.192.379c.07.135.164.197.299.197.193 0 .323-.161.323-.414h.228c0 .253.129.414.322.414.135 0 .23-.061.3-.197l.191-.38.02.425c.008.149.073.208.234.208.166 0 .282-.108.358-.352l.169-.54zm-1.771 1.16c-.292.018-1.908.125-2.153.24q-.008.002-.014.003.055.021.148.044c.144.033.35.065.592.094.474.057 1.039.093 1.487.096a14 14 0 0 0 1.489-.096c.242-.029.447-.061.591-.094a1 1 0 0 0 .167-.05l.03-.015q.003-.027.011-.06c-.05.075-.113.116-.194.078-.245-.115-1.864-.222-2.154-.24m1.615-.814a.5.5 0 0 1-.34.197c.713.1 1.218.242 1.234.246 0 0-.013.11-.044.236q.048-.1.115-.223l.01-.014.133-.125c-.185.033-.318.033-.39-.025a.9.9 0 0 1-.385.012c-.157-.026-.267-.13-.333-.304m-3.205 0c-.066.173-.175.278-.332.304a.9.9 0 0 1-.386-.012c-.055.045-.15.055-.276.042l.107.1c.123-.032.59-.15 1.213-.238a.5.5 0 0 1-.326-.196m2.394.023a.5.5 0 0 1-.196.104q.178.013.346.03a.36.36 0 0 1-.15-.134m-1.582 0a.36.36 0 0 1-.145.13q.163-.016.334-.028a.5.5 0 0 1-.19-.102m.79-.112a.5.5 0 0 1-.224.196q.083-.004.167-.005v-.002h.09v.002q.098 0 .195.006a.5.5 0 0 1-.227-.197"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#005BBF",
  fillRule: "evenodd",
  d: "M11.112 5.347a.336.336 0 1 0 0-.672.336.336 0 0 0 0 .672",
  clipRule: "evenodd"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#C88A02",
  fillRule: "evenodd",
  d: "M7.785 7.265c.09-.027.197.07.243.218a.4.4 0 0 1 .018.111.4.4 0 0 1 .121-.1c.137-.072.283-.064.326.018s-.032.207-.168.28c-.137.072-.282.064-.326-.017l-.003-.007a.1.1 0 0 1-.046.032c-.09.027-.198-.07-.244-.219-.045-.147-.01-.289.08-.316m6.575-.035c.088.027.124.17.079.317-.045.148-.154.246-.242.219a.1.1 0 0 1-.048-.032l-.002.007c-.044.081-.19.089-.326.016-.137-.072-.213-.198-.17-.28.044-.082.19-.089.327-.017q.075.042.12.098a.5.5 0 0 1 .02-.11c.045-.147.153-.245.242-.218m-5.034-.428c.09-.017.188.09.217.242a.4.4 0 0 1 0 .155.5.5 0 0 1 .114-.015c.154 0 .279.075.279.168s-.125.168-.28.168c-.154 0-.28-.075-.28-.168l.001-.006h-.003l.002.006c0 .093-.125.168-.28.168s-.28-.075-.28-.168.126-.168.28-.168c.057 0 .108.014.152.031a.5.5 0 0 1-.034-.106c-.03-.152.02-.29.112-.307m3.455-.042c.092-.004.174.117.182.272a.4.4 0 0 1-.023.152.5.5 0 0 1 .115.002c.153.022.267.113.254.205s-.148.148-.3.127c-.154-.022-.268-.113-.255-.205l.001-.007h-.002q.001.003.001.007c-.013.092-.147.148-.3.127-.154-.022-.267-.113-.255-.205.014-.092.148-.149.301-.127a.4.4 0 0 1 .146.05.5.5 0 0 1-.019-.109c-.008-.154.06-.284.154-.289m-1.776-.07c.091-.018.19.091.219.243a.4.4 0 0 1-.002.153.5.5 0 0 1 .114-.013c.155 0 .28.075.28.168 0 .092-.125.168-.28.168-.154 0-.28-.076-.28-.168l.001-.007-.003-.001.002.008c0 .092-.126.168-.28.168s-.28-.076-.28-.168.125-.168.28-.168q.086.002.153.03a.4.4 0 0 1-.035-.106c-.03-.152.02-.29.111-.307",
  clipRule: "evenodd"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#C88A02",
  d: "M11.22 4.224h.153v.233h-.153v.467h.153v.234h-.541v-.234h.155v-.467h-.155v-.233h.155v-.147h.233zM10.944 5.344h.448V6.8h-.448z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.14 5.588 9.14 5.7c-.993-.018-1.563.127-1.708.416q-.225.447.088 1.093l-.1.05q-.337-.693-.088-1.193c.172-.343.775-.496 1.81-.478"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m9.333 6.581-.058.096c-.216-.129-.324-.35-.324-.653 0-.437.225-.692.722-.868q.476-.166 1.302.134l-.038.105q-.793-.286-1.227-.133c-.456.16-.647.378-.647.762q0 .398.27.557"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "#C88A02",
  d: "m7.66 7.037-.211.075c-.22-.625-.157-1.049.218-1.232q.494-.24 1.446-.2l-.01.223q-.9-.035-1.338.179c-.246.12-.291.425-.105.955"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "#C88A02",
  d: "M10.13 5.439c-.513 0-.723.124-.843.493-.077.234-.003.435.238.622l-.137.177c-.312-.242-.422-.539-.314-.869.153-.47.453-.647 1.055-.647q.594-.001.916.314l.034.033v1.08h-.224v-.984q-.25-.219-.726-.22"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m13.049 5.7.002.112c.993-.018 1.563.127 1.707.416q.226.448-.087 1.093l.1.05q.337-.692.087-1.193c-.171-.343-.774-.496-1.809-.478"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m12.698 6.604.058.096c.216-.129.324-.35.324-.653 0-.436-.225-.692-.722-.867q-.475-.167-1.302.133l.038.106q.795-.287 1.227-.134c.456.16.647.379.647.762 0 .267-.09.45-.27.557"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  fill: "#C88A02",
  d: "m14.6 7.15.21.074c.22-.625.157-1.049-.218-1.232q-.494-.24-1.445-.2l.009.223q.9-.035 1.338.179c.247.12.292.425.105.955"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  fill: "#C88A02",
  d: "M12.117 5.456c.513 0 .723.125.843.493.077.235.002.435-.239.622l.138.177c.312-.242.422-.539.314-.868-.153-.47-.454-.648-1.056-.648q-.593 0-.916.315l-.033.033v1.08h.224v-.985q.25-.218.725-.219"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  fill: "#E1E5E8",
  fillRule: "evenodd",
  d: "M7.472 9.264h7.28v6.54S14.212 18 11.112 18s-3.64-2.253-3.64-2.253z",
  clipRule: "evenodd",
  opacity: 0.3
})), /*#__PURE__*/React.createElement("mask", {
  id: "flag-es_svg__e",
  width: 8,
  height: 9,
  x: 7,
  y: 9,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M7.472 9.264h7.28v6.54S14.212 18 11.112 18s-3.64-2.253-3.64-2.253z",
  clipRule: "evenodd"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#flag-es_svg__e)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFC034",
  d: "M7.472 13.296h3.696v4.368H7.472z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#AD1619",
  d: "M7.92 13.52h.448v4.144H7.92zM9.488 13.52h.448v4.144h-.448zM8.704 13.52h.448v4.144h-.448zM10.272 13.52h.448v4.144h-.448zM7.472 9.152h3.696v4.256H7.472z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#AD1619",
  d: "M11.056 13.184h3.696v4.256h-3.696z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F1F9FF",
  d: "M11.056 9.264h3.92v4.144h-3.92z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C88A02",
  d: "M9.376 10.529H9.6v-.464h.336v.464h.335v.58h-.335v1.047h.335v.58H8.256v-.58h.336V11.11h-.336v-.581h.223v-.464h.336v.464h.225V9.6h.336z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C37C9C",
  fillRule: "evenodd",
  d: "M12.626 9.805c.267-.107.577.005.84.381.151.215.151.452.005.64a.8.8 0 0 1-.3.224c.094.132.15.207.247.316q.069.078.122.148a.7.7 0 0 1 .161-.06l.08-.025c.093-.031.09-.02.09-.29v-.042c0-.068-.003-.125-.009-.257v-.013c-.02-.484-.002-.67.146-.803l.15.167c-.072.065-.088.232-.072.626v.014c.006.135.008.194.008.266v.042c0 .356-.027.43-.241.503l-.092.027-.023.007c-.03.01-.054.014-.069.02q.032.055.052.1c.06.146.04.285-.07.363v.006l.005.02c.013.052.01.107-.013.32a.8.8 0 0 0-.006.223c-.008-.02-.035-.044-.074-.043l-.006-.006-.006.005h.012l.008.007-.011.003-.011-.01-.02.022.001-.001a.1.1 0 0 1 .03-.01l.148.134c-.094.104-.23.12-.282-.025-.024-.066-.024-.168-.006-.324.02-.181.022-.225.018-.242l-.006-.027a1 1 0 0 1-.013-.172l-.088.192c-.1-.046-.151-.088-.164-.16a.2.2 0 0 1 .005-.074l.012-.036c.011-.032.008-.051-.042-.12q-.019-.026-.038-.055l-.013-.004a2 2 0 0 0-.135-.034q.018.047.044.105c.002.006.062.137.076.172.03.073.046.127.049.181.013.23-.172.285-.403.217a1.7 1.7 0 0 0-.285-.07c.076-.003.118-.086.113-.118l-.332.052c-.023-.143.04-.266.21-.27.064-.002.147.014.302.058l-.038-.087a2 2 0 0 1-.085-.22c-.058-.193.04-.344.226-.363h.03q-.06-.101-.128-.219-.036.009-.069.015l-.014-.087a2.4 2.4 0 0 1-.279.274c-.223.175-.43.234-.587.06l.251-.224c-.008-.01-.022-.013-.014-.015a.5.5 0 0 0 .142-.085q.095-.077.198-.19a1.3 1.3 0 0 1-.276-.257 1 1 0 0 0-.182-.175c-.027-.02-.11-.065-.122-.072-.138-.094-.13-.182-.047-.393l.313.124-.01.027.057.037q.122.082.25.239a.9.9 0 0 0 .24.214l-.004-.03.086-.018q.104-.024.195-.058a.7.7 0 0 0 .14-.07c-.074-.105-.134-.157-.176-.172-.006-.002 0-.002.007-.005a.2.2 0 0 0 .03-.018l-.333-.45a.4.4 0 0 1 .095-.052m.785 2.122a.3.3 0 0 1-.01.09l.018.008v-.01l-.002-.074z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C88A02",
  d: "m12.979 9.795.23-.245.48.45-.229.245z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFC034",
  d: "m14.36 16.14-.005.02c-.143.59-.625.888-1.395.888s-1.254-.306-1.395-.91l-.005-.018v-2.432h2.8zm-2.464-.06c.107.423.445.632 1.064.632s.957-.203 1.064-.613v-2.075h-2.128z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFC034",
  d: "m13.076 14.887.811-.883.165.152-.832.905h.931v.336h-.948l.85.925-.166.151-.811-.884v1.183h-.234v-1.3l-.92 1.001-.164-.151.848-.925h-.77v-.336h.755l-.833-.905.165-.152.92 1v-1.111h.233z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F1F9FF",
  fillRule: "evenodd",
  d: "M13.483 17.443s-2.373.186-2.373-1.344c0 0-.022 1.344-2.5 1.344v1.207h4.873z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#005BBF",
  fillRule: "evenodd",
  stroke: "#AD1619",
  strokeWidth: 1.167,
  d: "M11.112 14.192c.464 0 .84-.401.84-.896s-.376-.896-.84-.896-.84.401-.84.896.376.896.84.896Z",
  clipRule: "evenodd"
}))))));
export default SvgFlagEs;